import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class FeatureFlagService {
  constructor() {}

  isFlagEnabled(flag: string) {
    const flags = environment.flags;

    if (flags[flag]) {
      return flags[flag] === 'true';
    } else {
      return false;
    }
  }
}
